
import TitlePages from '../TitlePages'
export default {
  components: {
    TitlePages
  },
  data () {
    return {
      slide: 1,
      data: {
        img: 'news',
        title: 'Factocvcsry Opening',
        date: '04/03/2020',
        info: [
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.',
          ' Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat,'
        ]
      }
    }
  },
  mounted () {
    this.GetdataWorkInfo(this.$route.params.title)
  },
  methods: {
    GetdataWorkInfo (title) {
      this.$axios.get(`https://${this.$host}/news/` + title).then(res => {
        if (res.status === 200) {
          this.data = res.data
          console.log(this.data)
        }
      })

    }
  }
}
